import React, { useState, useEffect } from "react";
import { ClipLoader } from "react-spinners";
import { PieChart, Pie, Legend, Cell, Tooltip } from "recharts";
import { Row, Col, Card, CardHeader, CardTitle, CardBody } from "reactstrap";

import api from "../../../../../services/api";
import useCancelableFetch from "../../../../../hooks/useCancelableFetch";
import { useCompanies } from "../../../../../hooks/companies"; // Importa o hook useCompanies

// Mesma paleta usada antes na quebra CIF/FOB do card "Frete sobre NF"
const COLORS = {
  CIF: "#1d8cf8",
  FOB: "#00f2c3",
  Outro: "#ff8d72",
  "Sem informação": "#6c757d",
};

// PO1-2712 (revisão pós-QA): quantidade de NF por modalidade CIF/FOB, em
// substituição à quebra de % frete/NF que saiu do ChartFretePorNf — FOB não
// tem "% de frete" comparável a CIF (o cliente já paga/contrata o próprio
// frete), então aqui é só volume de notas, não valor.
export default function ChartNfPorModalidade({ deferLoad = false, onRegisterFetch }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { empresa, transportadora, arrayParams } = useCompanies(); // Obtém as seleções de empresa e transportadora

  async function loadCharts() {
    const controller = createController();
    try {
      setLoading(true);
      const params = {};

      if (arrayParams.embarcadores) {
        params.embarcadores = arrayParams.embarcadores;
      }

      if (arrayParams.transportadoras) {
        params.transportadoras = arrayParams.transportadoras;
      }

      const response = await api.get("/dashboard/custo/nf-por-modalidade-frete", {
        params,
        signal: controller.signal,
      });

      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      if (error && error.code === "ERR_CANCELED") {
        // aborted
      } else {
        console.error("Erro ao carregar NF por modalidade:", error);
      }
    } finally {
      setLoading(false);
    }
  }

  const { createController } = useCancelableFetch(30000);

  useEffect(() => {
    if (onRegisterFetch) onRegisterFetch(loadCharts);
    if (!deferLoad) {
      if (empresa) loadCharts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresa, transportadora]);

  return (
    <Card
      style={{ boxShadow: "0px 1px 20px 0px rgb(0, 0, 0)" }}
      className="card-chart"
    >
      <CardHeader>
        <Row style={{ alignItems: "center" }}>
          <Col>
            {/* minHeight reserva a mesma altura das 2 linhas de título dos
                cards vizinhos (Status de aprovação/divergência/pagamento),
                que aqui cabe em 1 linha só */}
            <h4 style={{ minHeight: 50 }}>NF por modalidade de frete</h4>
          </Col>
          <Col />
        </Row>
        <CardTitle>Quantidade de notas fiscais CIF x FOB</CardTitle>
      </CardHeader>
      <CardBody>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <ClipLoader sizeUnit="px" size={90} color="#1d8cf8" loading={loading} />
            <br />
            <br />
            <h1 className="text-info" style={{ textAlign: "center" }}>
              Carregando ...
            </h1>
          </div>
        ) : data.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px 0", color: "var(--everlog-card-muted)" }}>
            Sem notas fiscais no período.
          </div>
        ) : (
          <Row className="justify-content-center">
            <PieChart
              width={400}
              height={300}
              margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
            >
              <Tooltip formatter={(value) => `${value} NF`} />
              <Legend />
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={70}
                outerRadius={110}
                label
                paddingAngle={5}
              >
                {data.map((entry) => (
                  <Cell key={entry.name} fill={COLORS[entry.name] || "#6c757d"} />
                ))}
              </Pie>
            </PieChart>
          </Row>
        )}
      </CardBody>
    </Card>
  );
}
